var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass:
        "border border-primary-500 rounded-full px-2 py-0.5 inline-flex items-center min-h-6 placeholder-black",
      class: _vm.containerClasses,
      style: _vm.tagMaxWidth,
    },
    [
      _c(
        "span",
        { staticClass: "pr-4 block relative w-full truncate" },
        [
          _vm._t(
            "name",
            function () {
              return [
                _c("span", { style: _vm.tagMaxWidth }, [
                  _vm._v(" " + _vm._s(_vm.option.name) + " "),
                ]),
              ]
            },
            { option: _vm.option }
          ),
          _c("button", {
            staticClass:
              "absolute right-0 top-0 mdi mdi-close cursor-pointer focus:outline-none",
            attrs: { type: "button" },
            on: {
              mousedown: function ($event) {
                return _vm.$emit("remove", _vm.option)
              },
            },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }